import { Routes } from '@angular/router';
import { BatchesComponent } from './batches/batches.component';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import { AdminComponent } from './admin/admin.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BatchComponent } from './batch/batch.component';
import { UserComponent } from './user/user.component';
import { LoginComponent } from './login/login.component';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { unauthorizedGuard } from './guards/unauthorized.guard';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { StoresComponent } from './stores/stores.component';
import { ScanmedicationComponent } from './scanmedication/scanmedication.component';
import { ProductsComponent } from './products/products.component';
import { adminGuard } from './guards/admin.guard';
import { PickComponent } from './batchpick/pick/pick.component';
import { VerifyBasketsComponent } from './batchpick/verify/verify-baskets.component';
import { VerifyBasketComponent } from './batchpick/verify/verify-basket.component';
import { IssuesComponent } from './batchpick/issues/issues.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: 'batch/:batchId',
        component: BatchesComponent,
        canActivate: [unauthorizedGuard],
        canDeactivate: [unsavedChangesGuard]
    },
    {
        path: 'bad-request',
        component: ErrorpageComponent
    },
    {
        path: 'admin',
        component: AdminComponent,
        canActivate: [unauthorizedGuard]
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [unauthorizedGuard]
    },
    {
        path: 'batchlist',
        component: BatchComponent,
        canActivate: [unauthorizedGuard]
    },
    {
        path: 'user',
        component: UserComponent,
        canActivate: [unauthorizedGuard]
    },
    {
        path: 'store',
        component: StoresComponent,
        canActivate: [unauthorizedGuard]
    },
    {
        path: 'products',
        component: ProductsComponent,
        canActivate: [unauthorizedGuard, adminGuard]
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'unauthorized',
        component: UnauthorizedComponent
    },
    {
        path: 'scanmedication/:batchId',
        component: ScanmedicationComponent,
        canActivate: [unauthorizedGuard]
    },
    {
        path: 'batchpick/:batchId/pick',
        component: PickComponent,
        canActivate: [unauthorizedGuard],
        canDeactivate: [unsavedChangesGuard],
    },
    {
        path: 'batchpick/:batchId/verify',
        component: VerifyBasketsComponent,
        canActivate: [unauthorizedGuard],
    },
    {
        path: 'batchpick/:batchId/verify/issues',
        component: IssuesComponent,
        canActivate: [unauthorizedGuard],
    },
    {
        path: 'batchpick/:batchId/verify/:n',
        component: VerifyBasketComponent,
        canActivate: [unauthorizedGuard],
        canDeactivate: [unsavedChangesGuard],
    },
    {
        path: '**',
        redirectTo: 'login',
        pathMatch: 'full'
    }
]
